export default {
  anyMistakes:
    'Hvis du mener, at oplysningerne på denne side er forkerte, bedes du',
  contactUs: 'kontakte os',
  social: 'Vi er sociale | Følg os',
}
